import { render, staticRenderFns } from "./titleTab.vue?vue&type=template&id=80eb2ea2&scoped=true"
import script from "./titleTab.vue?vue&type=script&lang=js"
export * from "./titleTab.vue?vue&type=script&lang=js"
import style0 from "./titleTab.vue?vue&type=style&index=0&id=80eb2ea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eb2ea2",
  null
  
)

export default component.exports